module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia5-eb4cf0cfb58541a6eaa8b2e76d481d00.jpg";